import React from 'react';

export const TrackingSpot = (): React.ReactElement => (
  <svg
    fill="none"
    height="56"
    viewBox="0 0 56 56"
    width="56"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="27.6969" cy="28.0573" fill="#F7F5F0" r="27.6784" />
    <path
      d="M11.0186 17.9411C11.0186 17.0783 11.8134 16.3789 12.7938 16.3789H31.6118C32.5922 16.3789 33.387 17.0783 33.387 17.9411V36.0632H12.7938C11.8134 36.0632 11.0186 35.3637 11.0186 34.5009V17.9411Z"
      fill="#38AF88"
    />
    <path
      d="M33.3867 25.3246C33.3867 24.3363 34.2846 23.5352 35.3922 23.5352H39.2754C39.9771 23.5352 40.6278 23.8624 40.9911 24.398L44.7285 29.908C44.9181 30.1874 45.0183 30.5079 45.0183 30.8346V34.272C45.0183 35.2603 44.1205 36.0615 43.0129 36.0615H33.3867V25.3246Z"
      fill="#184634"
    />
    <path
      d="M36.0713 26.2227H39.3109L41.4397 29.1369V31.5911H36.0713V26.2227Z"
      fill="white"
    />
    <path
      d="M20.8608 36.5105C20.8608 38.24 19.4588 39.6421 17.7292 39.6421C15.9997 39.6421 14.5977 38.24 14.5977 36.5105C14.5977 34.781 15.9997 33.3789 17.7292 33.3789C19.4588 33.3789 20.8608 34.781 20.8608 36.5105Z"
      fill="#25694F"
    />
    <path
      d="M42.3345 36.5105C42.3345 38.24 40.9324 39.6421 39.2029 39.6421C37.4733 39.6421 36.0713 38.24 36.0713 36.5105C36.0713 34.781 37.4733 33.3789 39.2029 33.3789C40.9324 33.3789 42.3345 34.781 42.3345 36.5105Z"
      fill="#25694F"
    />
  </svg>
);
